export class IboxtoolsItemUnico {
    public id:number;
	public title:string;
    public desde:any;
    public hasta:any;
    
    constructor(data:any){
        this.id = data?.id;
        this.desde = data?.fecha;
        this.hasta = data?.fecha;
    }
}
